import * as lscache from "lscache";
import {Dispatch} from "redux";
import {apiLink} from "@web2/ap-api-routes";
import {apAppLink} from "@web2/ap-routes";

import {postAuthorizedRequest} from "../../app/utils/authorized_request";
import {apHistory} from "../../app/utils/history";
import {APLocalStorageKeys} from "../../app/utils/ls_cache_keys";
import {fetchUserInfoActionTypes} from "./get_user_info";

export const logOut = () => (dispatch: Dispatch) => {
    const url = apiLink.account.logout({});
    return postAuthorizedRequest(url(null), {}).finally(() => {
        // does not matter if backend fails to clear user session, we log out anyway
        lscache.remove(APLocalStorageKeys.USER_DATA);
        dispatch({type: fetchUserInfoActionTypes.reset});
        apHistory.push(apAppLink.login());
        return false;
    });
};
